import buscarProdutoListener from './BuscarProdutoListener'
import keycloakListener from './KeycloakListener'
import buscarUsuarioLogadoListener from './BuscarUsuarioLogadoListener'
import buscarParametrosListener from './BuscarParametrosListener'
import buscarLinguagemListener from './BuscarLinguagemListener'
import setFusoHorarioListener from './SetFusoHorarioListener'
import setMenuAvatarListener from './SetMenuAvatarListener'
import setApiArquivoListener from './SetApiArquivoListener'
import buscarDominioPerfilUsuarioListener from './BuscarDominioPerfilUsuarioListener'
import registerGlobalComponentsListener from './RegisterGlobalComponentsListener'
import interceptadorHttp from './InterceptadorHttp'

export default {
    buscarProdutoListener,
    keycloakListener,
    buscarUsuarioLogadoListener,
    buscarDominioPerfilUsuarioListener,
    buscarParametrosListener,
    buscarLinguagemListener,
    setFusoHorarioListener,
    setMenuAvatarListener,
    setApiArquivoListener,
    registerGlobalComponentsListener,
    interceptadorHttp
}
